function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.514 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.255 16.136h5.9a1.616 1.616 0 0 0 1.805-1.822V9.358h-4.149a.9.9 0 0 1-1.024-1.024v-4.2H8.255A1.62 1.62 0 0 0 6.45 5.963v8.351a1.618 1.618 0 0 0 1.805 1.822zm3.66-7.587h3.993a1.512 1.512 0 0 0-.5-.786L12.375 4.7a1.474 1.474 0 0 0-.781-.5v4.028a.287.287 0 0 0 .322.321zm-.708 1.851a.454.454 0 0 1 .465.449v1.831l-.039.825.415-.432.454-.46a.453.453 0 0 1 .31-.144.406.406 0 0 1 .426.41.41.41 0 0 1-.15.316L11.567 14.6a.518.518 0 0 1-.36.161.506.506 0 0 1-.354-.161l-1.529-1.4a.41.41 0 0 1-.15-.316.406.406 0 0 1 .426-.41.464.464 0 0 1 .31.144l.454.46.421.432-.044-.825v-1.832a.454.454 0 0 1 .466-.453z",
    transform: "translate(-6.45 -4.136)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFilled);
export default __webpack_public_path__ + "static/media/download-filled.d7a374f4.svg";
export { ForwardRef as ReactComponent };